import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import MainLoader from "../components/sub/MainLoader";
import { useGlobalSettings } from "../context/GlobalSettingsContext";

function SetupAccountRoute() {
  const userState = useSelector((state) => state.userState.value);
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );
  const { defaultLandingPage } = useGlobalSettings();
  if (userState.username) {
    if (setupAccountState) {
      return <Navigate to={defaultLandingPage || "/my-plans"} replace />;
    } else {
      return <Outlet />;
    }
  }
  return <MainLoader />;
}

export default SetupAccountRoute;
